var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallHelp = function SvgCallHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__a)",
    d: "M11.81 11.56c-3.971 1.548-6.569 5.428-6.402 9.69.216 5.413 1.532 13.622 6.127 24.029 8.66 19.616 15.62 24.103 20.598 22.954 1.291-.3 9.392-3.405 14.246-5.511a3.81 3.81 0 0 0 1.89-5.204l-4.355-9.858a3.815 3.815 0 0 0-4.854-1.831l-9.966 4.18s-7.176-9.284-9.058-21.556l8.226-3.364a3.94 3.94 0 0 0 2.056-5.354l-4.154-9.8a3.936 3.936 0 0 0-4.979-1.964l-9.383 3.58z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__b)",
    d: "M11.81 11.56c-3.971 1.548-6.569 5.428-6.402 9.69.216 5.413 1.532 13.622 6.127 24.029 8.66 19.616 15.62 24.103 20.598 22.954 1.291-.3 9.392-3.405 14.246-5.511a3.81 3.81 0 0 0 1.89-5.204l-4.355-9.858a3.815 3.815 0 0 0-4.854-1.831l-9.966 4.18s-7.176-9.284-9.058-21.556l8.226-3.364a3.94 3.94 0 0 0 2.056-5.354l-4.154-9.8a3.936 3.936 0 0 0-4.979-1.964l-9.383 3.58z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__c)",
    d: "m17.514 54.438 11.59-4.43c-.492-.65-7.228-9.774-9.06-21.555L8.489 32.14c.841 4.63 1.582 6.686 4.438 13.171.741 1.674 3.872 7.66 4.588 9.126"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__d)",
    d: "m28.27 25.097-8.3 3.389c-1.79.7-4.363-.092-5.062-1.874L10.703 15.84c-.7-1.79.075-3.863 1.857-4.563l8.7-3.305c1.973-.766 4.296.366 4.904 1.981l4.271 10.058c.825 2.223-.15 4.28-2.173 5.095z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__e)",
    d: "m45.58 63.071-8.026 3.347c-1.79.7-4.58.125-5.279-1.665l-4.829-10.19c-.7-1.79-.133-3.855 1.657-4.555l9.866-4.138c1.857-.857 4.196.117 4.954 1.79l4.454 10.05c.65 1.748.391 4.287-2.797 5.361"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__f)",
    d: "M22.837 23.429c2.717-1.119 3.972-4.328 2.802-7.168s-4.32-4.236-7.037-3.117-3.971 4.328-2.802 7.168 4.32 4.236 7.037 3.117",
    opacity: 0.53
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__g)",
    d: "M40.56 61.093c2.664-1.238 3.77-4.51 2.47-7.308-1.301-2.798-4.516-4.062-7.18-2.824-2.665 1.239-3.77 4.51-2.47 7.309 1.3 2.798 4.515 4.062 7.18 2.823",
    opacity: 0.53
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.757 17.923a.38.38 0 0 0 .228-.488.38.38 0 0 0-.491-.223l-2.038.754a.38.38 0 0 0-.228.488.38.38 0 0 0 .49.222z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__h)",
    d: "M21.682 17.946a.34.34 0 0 0 .204-.435.34.34 0 0 0-.437-.198l-2.008.742a.34.34 0 0 0-.203.435.34.34 0 0 0 .437.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.915 19.158a.38.38 0 0 0 .228-.488.38.38 0 0 0-.49-.223l-1.476.546a.38.38 0 0 0-.228.488.38.38 0 0 0 .49.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__i)",
    d: "M21.871 19.182a.34.34 0 0 0 .203-.434.34.34 0 0 0-.437-.198l-1.468.543a.34.34 0 0 0-.203.434.34.34 0 0 0 .437.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 16.906a.38.38 0 0 0 .227-.488.38.38 0 0 0-.49-.223l-1.476.546a.38.38 0 0 0-.228.488.38.38 0 0 0 .49.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__j)",
    d: "M20.952 16.914a.34.34 0 0 0 .203-.434.34.34 0 0 0-.437-.198l-1.468.543a.34.34 0 0 0-.203.434.34.34 0 0 0 .437.198z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.4 55.946a.38.38 0 0 0 .228-.488.38.38 0 0 0-.49-.222l-2.039.753a.38.38 0 0 0-.228.488.38.38 0 0 0 .491.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__k)",
    d: "M39.323 55.961a.34.34 0 0 0 .203-.434.34.34 0 0 0-.437-.198l-2.007.742a.34.34 0 0 0-.203.434.34.34 0 0 0 .437.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.559 57.181a.38.38 0 0 0 .227-.488.38.38 0 0 0-.49-.222l-1.476.545a.38.38 0 0 0-.228.488.38.38 0 0 0 .49.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__l)",
    d: "M39.512 57.198a.34.34 0 0 0 .203-.435.34.34 0 0 0-.437-.197l-1.468.542a.34.34 0 0 0-.204.435.34.34 0 0 0 .438.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.64 54.913a.38.38 0 0 0 .228-.488.38.38 0 0 0-.49-.222l-1.477.545a.38.38 0 0 0-.228.488.38.38 0 0 0 .491.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__m)",
    d: "M38.592 54.93a.34.34 0 0 0 .204-.435.34.34 0 0 0-.437-.198l-1.469.543a.34.34 0 0 0-.203.434.34.34 0 0 0 .437.198z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__n)",
    d: "m64.138 47.893-6.17-2.514c5.687-13.946-1.024-29.923-14.97-35.61L45.514 3.6c17.343 7.077 25.702 26.95 18.625 44.293"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#call-help_svg__o)",
    d: "m49.86 42.074-6.17-2.515c2.48-6.078-.45-13.03-6.52-15.51l2.515-6.17c9.475 3.863 14.037 14.72 10.174 24.195"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__a",
    x1: 10.595,
    x2: 61.149,
    y1: 46.153,
    y2: 21.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__d",
    x1: 13.609,
    x2: 27.754,
    y1: 20.951,
    y2: 15.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__e",
    x1: 27.163,
    x2: 48.66,
    y1: 56.136,
    y2: 56.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__f",
    x1: 25.038,
    x2: 16.587,
    y1: 16.292,
    y2: 20.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__g",
    x1: 42.231,
    x2: 36.311,
    y1: 53.369,
    y2: 57.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__h",
    x1: 25.386,
    x2: 24.752,
    y1: 19.301,
    y2: 17.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__i",
    x1: 23.377,
    x2: 22.814,
    y1: 20.745,
    y2: 18.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__j",
    x1: 22.2,
    x2: 21.637,
    y1: 18.495,
    y2: 16.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__k",
    x1: 53.756,
    x2: 53.123,
    y1: 56.312,
    y2: 54.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__l",
    x1: 45.48,
    x2: 44.917,
    y1: 58.587,
    y2: 56.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__m",
    x1: 44.3,
    x2: 43.737,
    y1: 56.328,
    y2: 54.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__n",
    x1: 52.44,
    x2: 55.629,
    y1: 67.226,
    y2: 7.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C47E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0BDF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "call-help_svg__o",
    x1: 42.216,
    x2: 45.413,
    y1: 66.676,
    y2: 7.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C47E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0BDF4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "call-help_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(63.05 -13.397 47.437)scale(44.8928 24.2421)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#666",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "call-help_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-31.62765 12.99725 -19.75584 -48.07409 44.626 28.216)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F1F2F2",
    stopOpacity: 0
  })))));
};
export default SvgCallHelp;